
import * as react from "react";
import * as reactRouter from "react-router-dom";

import * as tBox from "./tBox.js";
import { globalContext } from "./globalContext.js";

// import { ErrorLine } from "./ErrorLine.js";
import { DumpPanel } from "./DumpPanel.js";

import { SideBar } from "./SideBar.js";
import { TitlePanel } from "./TitlePanel.js";
import { FooterPanel } from "./FooterPanel.js";

// Map loaded lib here ...
const uuidv4 = window.uuidv4;
const moment = window.moment;

export async function dashboardLoader() {
    console.log("Dashboard loader start ...");
    return {
        date: moment().format("YYYY-MM-DD HH:mm:ss"),
        uuid: uuidv4(),
    };
};

let menuList = [];

export function Dashboard({ debugMode = false }) {
    const componentName = "Dashboard";
    if (debugMode) console.log(`${componentName} component start ...`);

    // let data = reactRouter.useLoaderData();
    const { config, localData, gsl, dataset,
        applicationDebugMode,
        applicationLanguage,
        updateApplicationLanguage,
        check4Right
    } = react.useContext(globalContext);

    // check from context
    if (applicationDebugMode !== undefined) debugMode = applicationDebugMode;
    let sl = tBox.getStringLabel(gsl, componentName);
    let [redraw, setRedraw] = react.useState(0);

    const navigate = reactRouter.useNavigate();

    react.useEffect(() => {
        if (debugMode) console.log(`Run ${componentName} on effect`);

        menuList = config?.menuList;    
        setRedraw((v) => v + 1);
   
    }, []);

    // event handling function here ...
   
    function click4MenuOption(e, record) {
        if (debugMode) console.log("Click for menu option", e, record);

        let url = record.url;
        let child = window.open(url);
        
        return;
    };

  

    return (
        <div className="container-fluid px-0">
            <style>
                {`
                .synap-btn-option:hover {
                    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
                }
                `}
            </style>

            <TitlePanel />
            <div className="d-flex ">
                <div style={{ ...(dataset?.sideBarWidth) }}>
                    <SideBar />
                </div>

                <div className="flex-fill" style={{ ...(dataset?.mainPanelWidth) }}>

                    <div className="container-fluid px-3" style={{ minHeight: "100vh", }}>
                        <div className="row g-3" >

                            <div className="col-12">
                                <h4 className="mt-3 fw-bold">{sl.l_title}</h4>
                            </div>

                            {
                                menuList.map((record, index) => {
                                    if (record.flag)
                                        return (
                                            <div key={index} className="col-3">
                                                <div className="d-flex flex-column justify-content-center align-items-center border rounded p-3 synap-btn-option"
                                                    role="button" onClick={(e) => click4MenuOption(e, record)}>
                                                    <span className="material-icons-outlined text-primary"
                                                        style={{ fontSize: "64px" }}>{record.icon}</span>
                                                    <div className="d-flex flex-column justify-content-center align-items-center "
                                                        style={{ height: "64px" }}>
                                                        <div className="fs-14-unity text-center"
                                                            dangerouslySetInnerHTML={{
                                                                __html: tBox.getLabel(sl, record.name, "l_")
                                                            }} >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    else return null;
                                })
                            }

                        </div>
                    </div>

                    <DumpPanel dataList={[
                        { name: "menuList", data: menuList },
                        { name: "config", data: config },
                        { name: "sl", data: sl },
                    ]} debugMode={debugMode} />

                </div>

            </div>


            <FooterPanel />
        </div>
    );
}